import AmexResyCreditCardSpecific from './AmexResyCreditCardSpecific';

export default AmexResyCreditCardSpecific;
